import config from "../../../config/config";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getToken } from "../../../utils/localStorageMethods";

const apiUrl = config.Url;

const baseQuery = fetchBaseQuery({
  baseUrl: `${apiUrl}/notifications`,
  credentials: "include",
  prepareHeaders: (headers) => {
    const token = getToken();
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const notificationsSlice = createApi({
  reducerPath: "notificationsSlice",
  baseQuery,
  tagTypes: ["notifications"],
  endpoints: (builder) => ({
    // Get recent notifications for bell icon
    getRecentNotifications: builder.query({
      query: (limit = 10) => `/recent?limit=${limit}`,
      providesTags: ["notifications"],
    }),
    // Get unread count only (fast)
    getUnreadNotificationCount: builder.query({
      query: () => `/unread-count`,
      providesTags: ["notifications"],
    }),
    // Mark all as read
    markAllNotificationsAsRead: builder.mutation({
      query: () => ({ url: "/mark-all-read", method: "POST" }),
      invalidatesTags: ["notifications"],
    }),
  }),
});

export const {
  useGetRecentNotificationsQuery,
  useGetUnreadNotificationCountQuery,
  useMarkAllNotificationsAsReadMutation,
} = notificationsSlice;
